<template>
    <vs-switch class="mt-2 " v-model="IsPublished" @click="setVal($event)" />
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: 'CellPublish',
  data() {
    return {
      IsPublished: true
    }
  },
  mounted(){
    //console.log(this.params)
    this.IsPublished  = this.params.value
  },
  methods:{
    setVal(event){
      let vm = this
      if (vm.IsPublished == true) {
        const { value: text } = Swal.fire({
          title: "This will clear existing Points for all Attendees in the event. Are you sure?",
          input: "text",
          inputPlaceholder: "Type 'clear' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase() == "clear") {
              vm.IsPublished = false;
              vm.params.setValue(false)
            } else {
              return "Try again! Please type 'clear' and hit Submit.";
            }
          },
        }).then(function (result) {
          if (result.dismiss != null) {
            vm.IsPublished = true
            vm.params.setValue(true)
          }
        });
      } else {
        vm.IsPublished = true
        vm.params.setValue(true)
      }
      
    }
  },
}
</script>